import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { StyledExtraSmallIcon } from 'components/shared/Icon/Icon.styles';
import NonRecurringIconBlack from 'components/mrp/components/Calendar/components/NonRecurringIconBlack/NonRecurringIconBlack';
import { EventResponse } from 'generated/index';

type RecurrenceCellProps = {
  row: EventResponse;
};

const RecurrenceCell = ({ row }: RecurrenceCellProps) => {
  const { t } = useTranslation('common');
  const isException = !row.isRecurring && row.isRecurringException;
  const isInfinite = row.recurrenceRule?.recurrenceRange?.type === 'NO_END';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      {isException ? (
        <NonRecurringIconBlack />
      ) : (
        <StyledExtraSmallIcon type="arrows-repeat" />
      )}
      {isInfinite && (
        <span>{t('appointmentsOverview.columns.recurrenceInfinite')}</span>
      )}
    </Box>
  );
};

export default RecurrenceCell;
